/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
import { store } from '@/store';

export function parseTime(time, cFormat) {
  if (arguments.length === 0) return null;

  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time))
      time = parseInt(time);

    if (typeof time === 'number' && time.toString().length === 10)
      time = time * 1000;

    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') return ['日', '一', '二', '三', '四', '五', '六'][value];
    if (result.length > 0 && value < 10) value = `0${value}`;

    return value || 0;
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (`${time}`.length === 10) time = parseInt(time) * 1000;
  else time = +time;

  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return `${Math.ceil(diff / 60)}分钟前`;
  } else if (diff < 3600 * 24) {
    return `${Math.ceil(diff / 3600)}小时前`;
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return `${
      d.getMonth() + 1
    }月${d.getDate()}日${d.getHours()}时${d.getMinutes()}分`;
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1];
  if (!search) return {};

  return JSON.parse(
    `{"${decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ')}"}`
  );
}

export function buildTree(
  list,
  parentId = 'CataloguePid',
  Id = 'CatalogueId',
  rootId = '0'
) {
  const arr = [...list];

  const rootList = arr.filter((item) => {
    if (item[parentId] === rootId) {
      item._level = 0;
      if (item.CataPrice === undefined || item.CataPrice === null) {
        item._buyInfo = { type: 'book' };
      }
      return item;
    }
  });

  function listToTreeData(bootItem, arr, parentId, Id, level) {
    bootItem.children = [];
    arr.forEach((item) => {
      if (item[parentId] === bootItem[Id]) {
        item._level = level + 1;
        /* 计算设置子节点不可读时 最近可读父节点 */
        if (item.CataPrice === undefined || item.CataPrice === null) {
          item._parentCata = bootItem._parentCata
            ? bootItem._parentCata
            : {
                CatalogueId: bootItem.CatalogueId,
                Title: bootItem.Title,
                CataPrice: bootItem.CataPrice,
                dcdOrder: bootItem.dcdOrder,
                BookId: bootItem.BookId,
                LocalFileUrl: bootItem.LocalFileUrl || '',
              };
        }
        bootItem.children.push({ ...item });
      }
    });

    if (bootItem.children.length > 0) {
      bootItem.children.forEach((item) => {
        listToTreeData(item, arr, parentId, Id, item._level);
      });
    } else {
      return false;
    }
  }

  rootList.map((rootItem) => {
    listToTreeData(rootItem, arr, parentId, Id, rootItem._level);
    return rootItem;
  });

  // console.error('rootList', rootList);

  return rootList;
}

export function getUrlParams(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ');
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split('&');
  searchArr.forEach((v) => {
    const index = v.indexOf('=');
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}

/**
 ** 乘法函数，用来得到精确的乘法结果
 ** 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
 ** 调用：accMul(arg1,arg2)
 ** 返回值：arg1乘以 arg2的精确结果
 **/
export function accMul(arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {}
  try {
    m += s2.split('.')[1].length;
  } catch (e) {}
  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
  );
}

/* 判断客户端类型（包含 iPadOS13+ 与平板识别，结果缓存） */
let __cachedIsPcResult;
export function isPC() {
  if (typeof __cachedIsPcResult === 'boolean') return __cachedIsPcResult;

  const ua = navigator.userAgent || navigator.vendor || window.opera;

  // iPadOS 13+ 会把 UA 伪装为 Macintosh，但存在触摸点
  const isIPadOS13 = /Macintosh/i.test(ua) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;

  // Android 平板：包含 Android 但不包含 Mobile
  const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua);

  // 其它常见平板
  const isTablet = /(iPad|Tablet|PlayBook|Silk)/i.test(ua) || isIPadOS13 || isAndroidTablet;

  // 常见手机
  const isPhone = /(iPhone|Android|Windows Phone|SymbianOS|iPod)/i.test(ua);

  const isMobile = isPhone || isTablet;
  __cachedIsPcResult = !isMobile;
  return __cachedIsPcResult;
}

export function errorImg(event){  
  event.target.src = store.state.appConfig.ERR_IMG
}

/**
 * 格式化价格，保留两位小数，不足时自动补充00
 * @param {number|string} price - 价格数值
 * @param {boolean} showSymbol - 是否显示货币符号，默认true
 * @param {string} symbol - 货币符号，默认'¥'
 * @returns {string} 格式化后的价格字符串
 */
export function formatPrice(price, showSymbol = true, symbol = '¥') {
  if (price === null || price === undefined || price === '') {
    return showSymbol ? `${symbol}0.00` : '0.00';
  }
  
  // 转换为数字
  const numPrice = Number(price);
  
  // 检查是否为有效数字
  if (isNaN(numPrice)) {
    return showSymbol ? `${symbol}0.00` : '0.00';
  }
  
  // 格式化为两位小数
  const formattedPrice = numPrice.toFixed(2);
  
  return showSymbol ? `${symbol}${formattedPrice}` : formattedPrice;
}

/**
 * 格式化价格（不显示货币符号）
 * @param {number|string} price - 价格数值
 * @returns {string} 格式化后的价格字符串
 */
export function formatPriceOnly(price) {
  return formatPrice(price, false);
}

/**
 * 计算折扣价格（处理浮点数精度问题）
 * @param {number} originalPrice - 原价
 * @param {number} discountRatio - 折扣比例（0-1之间的小数）
 * @returns {number} 折扣后的价格
 */
export function calculateDiscountPrice(originalPrice, discountRatio) {
  if (!originalPrice || !discountRatio) {
    return 0;
  }
  
  // 使用高精度乘法计算
  const discountPrice = accMul(originalPrice, discountRatio);
  
  // 返回保留两位小数的结果
  return Number(discountPrice.toFixed(2));
}

/**
 * 计算折扣显示文本（如：8.5折）
 * @param {number} discountRatio - 折扣比例（0-1之间的小数）
 * @returns {string} 折扣显示文本
 */
export function formatDiscountText(discountRatio) {
  if (!discountRatio) {
    return '无折扣';
  }
  
  // 将折扣比例转换为折数显示（如：0.85 -> 8.5折）
  const discountDisplay = (discountRatio * 10).toFixed(1);
  return `${discountDisplay}折`;
}

/**
 * 安全的价格计算（避免浮点数精度问题）
 * @param {number} price - 价格
 * @param {number} multiplier - 乘数
 * @returns {number} 计算结果
 */
export function safePriceMultiply(price, multiplier) {
  if (!price || !multiplier) {
    return 0;
  }
  
  // 使用高精度乘法
  const result = accMul(price, multiplier);
  
  // 返回保留两位小数的结果
  return Number(result.toFixed(2));
}


export function jumpToken (url) {
  if (!store.state.userInfo.accessToken) return url
  if (/\?/.test(url)) {
    return `${url}&token=${store.state.userInfo.accessToken}`
  } else {
    return `${url}?token=${store.state.userInfo.accessToken}`
  }
}